import PropTypes from 'prop-types';
import {errorIfMissingRequired, errorIfNoInput} from "./definition.errorcheck";
import {translateObjectArray} from "./definitions.arrayparse";

const authorsPropTypes = {
  author: PropTypes.string.isRequired,
  commits: PropTypes.number,
  commitPercent: PropTypes.number,
  filesDelta: PropTypes.number,
  additions: PropTypes.number,
  deletions: PropTypes.number,
  firstCommit: PropTypes.instanceOf(Date),
  latestCommit: PropTypes.instanceOf(Date)
}

const AuthorDetails = class {
  static propTypes = authorsPropTypes;

  constructor(author, commits, commitPercent, filesDelta, additions, deletions, firstCommit, latestCommit){
    this.author = author;
    this.commits = commits;
    this.commitPercent = commitPercent;
    this.filesDelta = filesDelta;
    this.additions = additions;
    this.deletions = deletions;
    this.firstCommit = firstCommit ? new Date(firstCommit) : null;
    this.latestCommit = latestCommit ? new Date(latestCommit) : null;
  }

  /**
   *
   * @param {{author: number, commits: number, commitPercent: number, filesDelta: number, additions: number, deletions: number, firstCommit: string, latestCommit: string}} object
   * @returns {AuthorDetails}
   */
  static translateObject(object) {
    errorIfNoInput(object);
    const requiredFields = {
      author: object.author
    }
    errorIfMissingRequired(requiredFields);

    return new AuthorDetails(object.author,
      object.commits,
      object.commitPercent,
      object.filesDelta,
      object.additions,
      object.deletions,
      object.firstCommit,
      object.latestCommit);
  }

  /**
   *
   * @param {{author: number, commits: number, commitPercent: number, filesDelta: number, additions: number, deletions: number, firstCommit: string, latestCommit: string}[]} array
   * @returns {AuthorDetails[]}
   */
  static translateObjectArray(array) {
    return translateObjectArray(array, this.translateObject);
  }
}

const GitlabData = class {
  static propTypes = {
    commits: PropTypes.number,
    nonMergeCommits: PropTypes.number,
    filesDelta: PropTypes.number,
    uniqueAuthors: PropTypes.number,
    firstCommit: PropTypes.instanceOf(Date),
    latestCommit: PropTypes.instanceOf(Date),
    authorDetails: PropTypes.arrayOf(PropTypes.shape(authorsPropTypes))
  }

  constructor(commits, nonMergeCommits, filesDelta, uniqueAuthors, firstCommit, latestCommit, authorDetails) {
    this.commits = commits;
    this.nonMergeCommits = nonMergeCommits;
    this.filesDelta = filesDelta;
    this.uniqueAuthors = uniqueAuthors;
    this.firstCommit = firstCommit ? new Date(firstCommit) : null;
    this.latestCommit = latestCommit ? new Date(latestCommit) : null;
    this.authorDetails = AuthorDetails.translateObjectArray(Object.values(authorDetails));
  }

  /**
   *
   * @param {{commits: number, nonMergeCommits: number, filesDelta: number, uniqueAuthors: number, firstCommit: string, latestCommit: string, authorDetails: {author: number, commits: number, commitPercent: number, filesDelta: number, additions: number, deletions: number, firstCommit: string, latestCommit: string}[]}} object
   * @returns {GitlabData}
   */
  static translateObject(object) {
    errorIfNoInput(object);
    const requiredFields = {
    }
    errorIfMissingRequired(requiredFields);

    return new GitlabData(object.commits,
      object.nonMergeCommits,
      object.filesDelta,
      object.uniqueAuthors,
      object.firstCommit,
      object.latestCommit,
      object.authorDetails);
  }

  /**
   *
   * @param {{commits: number, nonMergeCommits: number, filesDelta: number, uniqueAuthors: number, firstCommit: string, latestCommit: string, authorDetails: {author: number, commits: number, commitPercent: number, filesDelta: number, additions: number, deletions: number, firstCommit: string, latestCommit: string}[]}[]} array
   * @returns {GitlabData[]}
   */
  static translateObjectArray(array) {
    return translateObjectArray(array, this.translateObject);
  }
}

export default GitlabData;
